import {
  FETCH_PAGINATED_EXCISE_PERIODS,
  FETCH_ALL_EXCISE_PERIODS,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_EXCISE_PERIODS](state, { excisePeriods, pagination }) {
    state.items = excisePeriods;
    state.pagination = pagination;
  },

  [FETCH_ALL_EXCISE_PERIODS](state, excisePeriods) {
    state.all = excisePeriods;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/excisePeriod/mutations.js